module.exports = __webpack_public_path__ + "static/media/gift_5.1ebfd8c2.png";